<main>
  <loading-overlay [isLoading]="productionCardBundleService.isLoading()" />
  <p-confirmDialog />
  <header>
    <div>
      <h1>{{ 'Production_Card_Bundles_ProductionCardBundles' | translateWF: 'Production Card Bundles' }}</h1>
    </div>
  </header>

  <div class="content">
    <!-- Dyeing Information - shown in both modes -->
    <app-individual-production-card-general-information
      [showOrderInfo]="false"
      [showDyeingInfo]="true"
      [showManufacturerTable]="false"
      [showBalanceTable]="false"
      [showFabricsWithoutRolls]="true"
    />

    <app-fabric-summary-table [productionCard]="productionCard" [rolls]="rolls()" [fabrics]="fabrics" [bundles]="productionCardBundles" [showFabricsWithoutRolls]="true" />

    @if (showCreateBundlesButton) {
      <div class="create-bundles-action">
        <p-button (onClick)="createBundles()">{{ 'Production_Card_Bundles_CreateBundles' | translateWF: 'Create Bundles' }}</p-button>
      </div>
    }

    @if (viewMode === 'bundles') {
      <div class="row-start-center" [formGroup]="form">
        <p-toggle-switch formControlName="overrideTransferUnitView" inputId="override-transfer-unit-view" />
        <label for="override-transfer-unit-view" class="ml-2">
          {{
            form.controls.overrideTransferUnitView.value
              ? ('Production_Card_Bundles_HideRollsInBatching' | translateWF: 'Hide Rolls in Batching')
              : ('Production_Card_Bundles_ShowRollsInBatching' | translateWF: 'Show Rolls in Batching')
          }}
        </label>
      </div>

      @if (form.controls.overrideTransferUnitView.value) {
        <app-production-card-move-to-batch />
      }
      <div class="bundle-card-container">
        @for (bundle of productionCardBundles; track $index) {
          <div class="bundle-card" [class.selected]="selectedBundle?.id === bundle.id" (click)="selectBundle(bundle.id)">
            <h5>{{ bundle.number }}</h5>
            <p-tag [value]="productionCardBundleStatusValues[bundle.status]" [severity]="getStatusSeverity(bundle.status)" />
            @if (showActualWeight(bundle)) {
              <p>{{ 'Production_Card_Bundles_ActualWeight' | translateWF: 'Actual Weight' }}: {{ bundle.actualWeightInLbs | number: '1.0-2' }} lbs</p>
            } @else {
              <p>{{ getBundleActualWeightInLbs(bundle) | number: '1.0-2' }}/{{ bundle.expectedWeight | number: '1.0-2' }}lbs</p>
            }

            <p>{{ 'Production_Card_Bundles_RollsCount' | translateWF: 'Rolls count' }}: {{ bundle.rollNumbers.length }}</p>
          </div>
        }
      </div>

      @if (selectedBundle) {
        <p-panel [header]="'Production_Card_Bundles_Rolls' | translateWF: 'Rolls'">
          <p-card data-variant="compact">
            <div class="rolls-filter-section">
              @if (showStatusSelect()) {
                <div class="status-filter">
                  <label>{{ 'Production_Card_Bundles_Status' | translateWF: 'Status' }}</label>
                  <p-select
                    [options]="getStatusSelectOptions()"
                    [formControl]="selectedBundleStatusControl"
                    [placeholder]="'Production_Card_Bundles_SelectStatus' | translateWF: 'Select Status'"
                    styleClass="w-full"
                  />
                </div>
              }
              <div class="asset-filter">
                <label>{{ 'Production_Card_Bundles_BatchFoldingMachine' | translateWF: 'Batch Folding Machine' }}</label>
                <p-select
                  [options]="batchFoldingMachines"
                  [formControl]="selectedBundleAssetControl"
                  optionLabel="assetId"
                  optionValue="assetId"
                  [placeholder]="'Production_Card_Bundles_SelectMachine' | translateWF: 'Select Machine'"
                  [disabled]="selectedBundle.status !== ProductionCardBundleStatus.Processing"
                  styleClass="w-full"
                  (onChange)="updateBundleAsset($event.value)"
                />
              </div>
              @if (canBundleBeEdited(selectedBundle)) {
                <div class="search-filter">
                  <p-button (onClick)="addRollToBundle()">{{ 'Production_Card_Bundles_AddRoll' | translateWF: 'Add Roll' }}</p-button>
                  <label>{{ 'Production_Card_Bundles_RollNumber' | translateWF: 'Roll Number' }}</label>
                  <span class="p-input-icon-right w-full">
                    <input type="text" pInputText [formControl]="rollNumberToAdd" />
                  </span>
                </div>
              }
            </div>

            <app-rolls-display-table [selectedBundle]="selectedBundle" [isReadOnly]="isReadOnlyMode" [fabrics]="fabrics" (removedRollFromBundle)="removeRollFromBundle($event)" />
          </p-card>
        </p-panel>
      }
    } @else if (viewMode === 'transfer-units') {
      @if (showTransferUnitRollsComponent()) {
        <app-production-card-move-to-batch />
      }
    }
  </div>
</main>
